import moment from 'moment'

export function dateFormats () {
  return ['YYYY-MM-DD'] //, 'YYYY.MM.DD', 'YYYYMMDD', 'YY-MM-DD', 'YY.MM.DD', 'YYMMDD']
}

export function validateQuery (query) {
  return query && query.token
}

export function validateCookie (cookie) {
  return cookie && cookie.token && cookie.location
}

export function hasNoSpecialchars (string) {
  const regExpAllowed = /^[\w\d-_ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ ]*$/g
  return regExpAllowed.test(string)
}

export function validPhoneNumber (string) {
  return /^[-+ \d]+$/.test(string)
}

export function validEmail (string) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(string)
}

export function validDate (dateString, timeString) {
  const now = moment()
  const date = timeString ? moment(`${dateString}T${timeString}:59`) : moment(`${dateString}T23:59:59`)
  if (date.isBefore(now)) {
    return false
  }
  return true
}

export function validPrebooking (dateString, timeString) {
  const now = moment()
  const date = moment(`${dateString}T${timeString}:59`)
  const from = now.clone().add(2, 'minutes')
  const to   = now.clone().add(30, 'minutes')

  if (date.isBetween(from, to)) {
    return false
  }
  return true
}

export function dateAfterLimit (dateString) {
  const lastDate = moment().add(89, 'days')
  const date = moment(dateString, dateFormats(), true)
  return date.isAfter(lastDate)
}

export function validateDateFormat (dateString) {
  const m = moment(dateString, dateFormats(), true)
  return m.isValid()
}

export function validLocation (location) {
  return location && location.locationType && location.locationType !== 'STREET'
}
